(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-feeder-guides-index"]) return;
  try {
    
  (function () {
    var grid = document.getElementById('fg-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.fg-card'));
    var search = document.getElementById('fg-search');
    var chipsWrap = document.getElementById('fg-chips');
    var empty = document.getElementById('fg-empty');
    var activeCategory = 'all';

    var categories = [];
    cards.forEach(function (card) {
      var cat = card.getAttribute('data-category');
      if (cat && categories.indexOf(cat) === -1) categories.push(cat);
    });
    categories.sort();
    categories.forEach(function (cat) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fg-chip';
      btn.setAttribute('data-category', cat);
      btn.textContent = cat.charAt(0).toUpperCase() + cat.slice(1);
      chipsWrap.appendChild(btn);
    });

    function applyFilter() {
      var term = (search.value || '').trim().toLowerCase();
      var visibleCount = 0;
      cards.forEach(function (card) {
        var name = card.getAttribute('data-name') || '';
        var cat = card.getAttribute('data-category') || '';
        var matchesTerm = term === '' || name.indexOf(term) !== -1;
        var matchesCategory = activeCategory === 'all' || cat === activeCategory;
        var show = matchesTerm && matchesCategory;
        card.hidden = !show;
        if (show) visibleCount++;
      });
      empty.hidden = visibleCount !== 0;
    }

    search.addEventListener('input', applyFilter);
    chipsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.fg-chip');
      if (!btn) return;
      chipsWrap.querySelectorAll('.fg-chip').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      activeCategory = btn.getAttribute('data-category');
      applyFilter();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
